import { StadsprognoseConfig, CodeOption } from './apiRequests'

export type { StadsprognoseConfig, CodeOption }

export interface StuurkaartRow {
  jaar: number
  tfrn: number
  emic: number
  emuc: number
  salit: number
  salut: number
  finwh: number
  sexratioM: number
  stmc: number
  stvc: number
  fbewwon: number
}

export interface StadsprognoseFormData {
  naam: string
  omschrijving: string
  gemeente_code: string
  bjaar: number
  ejaar: number
  bron: string
  calc_method_salit: string
  calc_method_stk: string
  aanname_tfrn: string
  aanname_geb: string
  aanname_ste: string
  aanname_ver: string
  aanname_ves: string
  correctie_sexratio: boolean
  correctie_stk: number
  correctie_tfrn: string
  correctie_salut: boolean
  correctie_fbewwon: boolean
  afronden: string
  selected_wbp_code: string
  selected_ext_code: string
  selected_matrix_code: string
  stuurkaart_data: StuurkaartRow[] | null
}

export const defaultFormData: StadsprognoseFormData = {
  naam: '',
  omschrijving: '',
  gemeente_code: '',
  bjaar: 2025,
  ejaar: 2050,
  bron: 'import',
  calc_method_salit: 'hsr',
  calc_method_stk: 'gbpro',
  aanname_tfrn: '5',
  aanname_geb: '5',
  aanname_ste: '5',
  aanname_ver: '3',
  aanname_ves: '3',
  correctie_sexratio: false,
  correctie_stk: 1,
  correctie_tfrn: 'gemeente',
  correctie_salut: true,
  correctie_fbewwon: false,
  afronden: '0',
  selected_wbp_code: '',
  selected_ext_code: '',
  selected_matrix_code: '',
  stuurkaart_data: null,
}
